<template>
  <div class="container-edit">
    <div class="header">{{ company.company_name }}</div>
    <nav class="add-navigation flex flex-wrap">
      <div
        @click="$router.push({ name: 'system-admin-company-list' })"
        class="back-link "
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Company</p>
      </div>
      <div class="buttons-wrapper  pl-2 flex-wrap">
        <div
          @click="$router.push({ name: 'system-admin-company-list' })"
          class="secondary-button button-margin-size"
        >
          <secondary-button class="button_size">Cancel</secondary-button>
        </div>
        <div class="primary-button button-margin-size">
          <primary-button @click.native="editCompany"
            >Save Company</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="ml-3" >Edit Company</span>
      <loader :loading="loading" v-if="loading" />
      <div v-else class="row mt-3 p-3 ">


        <div class="col-md-6 col-12">
          <primary-input
            type="text"
            name="company name"
            class="field"
            :value="company.company_name"
            @input="handleCompanyName"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('company name') }"
            placeholder="Enter company name"
          />
          <div class="help is-danger" v-if="errors.has('company name')">
            {{ errors.first("company name") }}
          </div>
          </div>
        <div class="col-md-6 col-12">
          <primary-select
              type="text"
              name="reseller"
              class="mode input"
              v-model="company.reseller_uuid"
              placeholder="Select reseller"
              :options="resellers"
          />
        </div>
        <div class="col-md-6 col-12">
          <primary-input
              name="email"
              type="text"
              v-model="company.contact.email"
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('email') }"
              placeholder="Enter email"
          />
          <div v-if="errors.has('email')" class="help is-danger">
            {{ errors.first("email") }}
          </div>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
              type="text"
              name="address"
              v-validate="'required'"
              v-model="company.contact.address"
              :class="{ input: true, 'is-danger': errors.has('address') }"
              placeholder="Enter address"
          />
          <div class="help is-danger" v-if="errors.has('address')">
            {{ errors.first("address") }}
          </div>
        </div>

        <div class="col-md-6 col-12">
          <primary-input
                  type="text"
                  name="first name"
                  v-validate="'required'"
                  :value="company.contact.first_name"
                  @input="handleFirstName"
                  :class="{ input: true, 'is-danger': errors.has('first name') }"
                  placeholder="Enter first name"
          />
          <div class="help is-danger" v-if="errors.has('first name')">
            {{ errors.first("first name") }}
          </div>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
                  type="text"
                  name="last name"
                  v-validate="'required'"
                  :value="company.contact.last_name"
                  @input="handleLastName"
                  :class="{ input: true, 'is-danger': errors.has('last  name') }"
                  placeholder="Enter last name"
          />
          <div class="help is-danger" v-if="errors.has('last name')">
            {{ errors.first("last name") }}
          </div>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
              type="password"
              name="password"
              v-model="company.contact.passwd"
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('password') }"
              placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">
            {{ errors.first("password") }}
          </div>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
                  @input="PhonePatternHendler"
                  type="text"
                  name="phone"
                  v-model="phone_number"
                  v-validate="{required: true, regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/}"
                  :class="{ input: true, 'is-danger': errors.has('phone') }"
                  placeholder="Enter phone number"
          />
          <div v-if="errors.has('phone')" class="help is-danger">
            {{ errors.first("phone") }}
          </div>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
              :value="company.prepay === 'true' ? 'Prepay' : 'Postpay'"
              name="mode"
              class="mode input"
              :disabled="true"
          />
        </div>
        <div class="col-md-6 col-12">
          <primary-select
              type="text"
              name="Default ani group"
              class="input"
              v-model="company.default_ani_group_uuid"
              placeholder="Ani Group"
              :options="anis"
          ></primary-select>
        </div>
        <div class="col-md-6 col-12">
          <primary-input
              type="number"
              name="sms per sec"
              v-model="company.sms_per_sec"
              class="input"
              placeholder="Enter sms per sec"
          />
        </div>

          <!-- <div class="help is-danger" v-if="errors.has('reseller')">{{ errors.first('reseller') }}</div> -->

          <div class="col-md-6 col-12">
            <primary-select
                type="text"
                name="country"
                v-validate="'required'"
                v-model="company.contact.country_uuid"
                :class="{ input: true, 'is-danger': errors.has('country') }"
                placeholder="Country"
                :options="countries"
            />
          </div>


        <div class="col-md-6 col-12 wrapper-buttons">

            <primary-input
                type="text"
                name="state"
                class="state"
                v-validate="'required'"
                v-model="company.contact.state"
                :class="{ input: true, 'is-danger': errors.has('state') }"
                placeholder="state"
            ></primary-input>
            <primary-input
                type="text"
                name="city"
                v-validate="'required'"
                v-model="company.contact.city"
                :class="{ input: true, 'is-danger': errors.has('city') }"
                placeholder="Enter city"
            />
            <div class="help is-danger" v-if="errors.has('city')">
              {{ errors.first("city") }}

          </div>
        </div>
          <div class="col-md-6 col-12">
            <primary-input
                type="text"
                name="zipcode"
                v-model="company.contact.zipcode"
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('zipcode') }"
                placeholder="Enter zipcode"
            />
            <div class="help is-danger" v-if="errors.has('zipcode')">
              {{ errors.first("zipcode") }}
            </div>
          </div>
          <div class="col-md-6 col-12">
            <primary-select
                type="text"
                name="product"
                class="input"
                v-model="company.product"
                placeholder="Select product"
                :options="products"
            />
          </div>
          <div class="col-md-6 col-12">
            <template v-if="company.prepay === 'false'">
              <primary-select
                  type="text"
                  name="payment term"
                  v-model="company.payment_term_uuid"
                  :class="{ input: true, 'is-danger': errors.has('payment term') }"
                  placeholder="Payment Term"
                  :options="payments"
              />
              <div v-if="errors.has('payment term')" class="help is-danger">
                {{ errors.first("payment term") }}
              </div>
            </template>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    companyError: null,
    modes: [
      { name: "prepay", value: true },
      { name: "postpay", value: false },
    ],
    anis: [],
    products: [],
    resellers: [],
    payments: [
      {
        value: "",
        name: "",
      },
    ],
    company: {
      payment_term_uuid: null,
      credit: null,
      contact: {},
      reseller_uuid: null,
      prepay: null,
      default_ani_group_uuid: null,
      product: null,
      sms_per_sec: null
    },
    countries: [],
    loading: true,
    phone_number: null,
  }),
  computed: {
    ...mapGetters({
      ProductTotal: "products/getTotal",
    }),
  },
  async created() {
    this.getAniList();
    this.getResellerList();
    this.getProductList();
    await this.getCountries();
    await this.getPaymentTermList();
    await this.getCompany();
  },
  methods: {
    ...mapActions({
      GetProductList: "products/getProductList",
    }),
    transformReseller(item) {
      return {
        name: item.reseller_name,
        value: item.reseller_uuid,
      };
    },
    transformProduct(item) {
      return {
        name: item.product_name,
        value: item.product_uuid,
      };
    },
    splitByThree(string) {
      const new_array = [];
      for (let i = 0; i < string.length; i += 3) {
        new_array.push(string.slice(i, i + 3));
      }
      return new_array;
    },
    PhonePatternHendler(e) {
      if(this.phone_number.substring(0, 2) !== "00" && this.phone_number.substring(0, 1) !== "+") {
        this.phone_number = '+' + this.phone_number
      }
      // const value = e.replace(/[^+0-9.]/gi, "");
      // const value_array = this.splitByThree(value);
      //
      // this.phone_number = value_array.join("-");
    },
    getResellerList() {
      this.$store.dispatch("GetResellerList", {}).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetResellerList", { per_page: total })
          .then((res) => {
            this.resellers = [
              { name: "Select reseller", value: "" },
              ...res.items.map(this.transformReseller),
            ];
          });
      });
    },
    handleCompanyName(v) {
      this.company.company_name = this.$capitalize(v);
    },
    handleFirstName(v) {
      this.company.contact.first_name = this.$capitalize(v);
    },
    handleLastName(v) {
      this.company.contact.last_name = this.$capitalize(v);
    },
    getProductList() {
      this.GetProductList({}).then((res) => {
        this.GetProductList({ perPage: this.ProductTotal }).then((res) => {
          this.products = [
            { name: "Select product", value: null },
            ...res.map(this.transformProduct),
          ];
        });
      });
    },
    async getCompany() {
      this.loading = true;
      const res = await this.$store.dispatch("GetCompany", this.$route.params.id);
      this.phone_number = res.contact.phone;
      this.company = this.transformCompanies(res);
      this.loading = false;

      this.PhonePatternHendler(this.phone_number);
    },
    transformCompanies(i, k) {
      return {
        company_name: i.company_name,
        payment_term_uuid: i.payment_term_uuid,
        credit: i.credit,
        reseller_uuid: i.reseller_uuid,
        default_ani_group_uuid: i.default_ani_group_uuid,
        sms_per_sec: i.sms_per_sec,
        product: i.product,
        contact: {
          country_uuid: i.contact.country_uuid,
          email: i.contact.email,
          logo_file_uuid: i.contact.logo_file_uuid,
          first_name: i.contact.first_name,
          last_name: i.contact.last_name,
          city: i.contact.city,
          address: i.contact.address,
          state: i.contact.state,
          zipcode: i.contact.zipcode,
          phone: i.contact.phone,
          passwd: i.contact.passwd,
        },
        prepay: String(i.prepay),
      };
    },
    transformData(item) {
      return {
        name: item.ani_group_name,
        value: item.ani_group_uuid,
      };
    },
    getAniList() {
      this.$store
        .dispatch("GetAniList", {})
        .then((res) => {
          const { total } = res;
          this.$store
            .dispatch("GetAniList", { per_page: total })
            .then((res) => {
              this.anis = res.items.map(this.transformData);
              this.anis.unshift({ name: "Select ANI", value: null });
            })
            .catch((err) => this.$error(err));
        })
        .catch((err) => this.$error(err));
    },
    async getCountries() {
      const { items } = await this.$store.dispatch("getCountryList", {
        nice_name: this.countryName,
      });
      this.countries = items.map((i) => {
        return {
          name: i.nice_name ? i.nice_name : i.name,
          value: i.country_uuid,
        };
      });
    },
    async getPaymentTermList() {
      const { total } = await this.$store.dispatch("GetPaymentTerms", {});
      const { items } = await this.$store.dispatch("GetPaymentTerms", {
        total,
      });

      this.payments = [
        this.payments,
        ...items.map((item) => {
          return {
            value: item.payment_term_uuid,
            name: item.name ? item.name : "",
          };
        }),
      ];
    },
    editCompany: async function () {
      const valid = await this.$validator.validate();

      if (valid) {
        try {
          if (!this.company.product) {
            this.company.product = null;
          }
          if (!this.company.reseller_uuid) {
            delete this.company.reseller_uuid;
          }
          if (!this.company.default_ani_group_uuid) {
            delete this.company.default_ani_group_uuid;
          }
          if (this.company.prepay === "true") {
            this.company.payment_term_uuid = null;
          }
          if (!this.company.payment_term_uuid) {
            this.company.payment_term_uuid = null;
          }
          if (!this.company.sms_per_sec) {
            delete this.company.sms_per_sec
          }
          if (this.company.contact.passwd === '********') {
            delete this.company.contact.passwd
          }

          this.company.contact.phone = this.phone_number.split("-").join("");

          await this.$store.dispatch("EditCompanyInfo", {
            companyInfo: this.company,
            id: this.$route.params.id,
          });

          this.$snotify.success("Company have been changed.", {
            timeout: 6000,
          });

          this.$router.push({ name: "system-admin-company-list" });
        } catch (err) {
          if (err.errors) {
            this.companyError = err.errors[0].contact
              ? err.errors[0].contact
              : null;
            setTimeout(() => {
              this.companyError = null;
            }, 6000);
          } else if (err.response) {
            this.$snotify.error(
              err.response.data.errors
                ? err.response.data.errors
                : err.response.data.error.message,
              { timeout: 6000 }
            );
          } else {
            this.$snotify.error(err, { timeout: 6000 });
          }
        }
      }
    },
  },
};
</script>

<style>
.mode .pimary-input[disabled] {
  color: #000;
}
</style>

<style lang="scss" scoped>
.container-edit {
  width: 100%;
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .header {
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 160px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .primary-input-container[data-v-01567ff0] {
    width: 100%;
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    // height: fit-content;
    background-color: #ffffff;
    padding: 15px 0 15px;

    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 15px;
        padding-left: 0;
        .buttons-wrapper {
          display: flex;
          align-items: center;
          width: fit-content;
          width: 100%;

          .state {
            margin-right: 10px;
          }
          .credit {
            margin-right: 10px;
          }
        }
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.upload-photo,
#dropzone {
  min-height: 285px;
  min-height: 285px;
  border-radius: 4px;
  width: 100%;
  .dz-image {
    padding: 5px;
    img {
      height: 250px;
      width: 250px;
      border-radius: 50px;
      margin-left: -25px;
    }
  }
}
.pimary-input-title {
  color: #000000;
  font-family: "" Helvetica Neue "";
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.21px;
  line-height: 15px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.upload-contaioner {
  border: 1px solid #5171f3;
  border-radius: 4px;
  background-color: #ffffff;
  height: 265px;
  border-style: dashed;
  margin-right: 15px;
  position: relative;
  input[type="file"] {
    position: absolute;
    height: 36px;
    width: 136px;
    opacity: 0;
    cursor: pointer;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%); /* IE 9 fix */
    z-index: 1;
  }
  .upload-button {
    height: 36px;
    width: 136px;
    border-radius: 4px;
    background-color: #51a3f3;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.wrapper-buttons{
  display: flex;
  align-items: center;
  width: fit-content;
  width: 100%;
  .state {
    margin-right: 10px;
  }
  .credit {
    margin-right: 10px;
  }
}
.row .input{
  margin-bottom: 20px;
}
</style>
<style scoped>

@media (max-width: 377px) {
  .button_size{
    width: 160px!important;
  }
}
@media (max-width: 540px) {
  .button-margin-size{
    margin-top: 16px;
  }
}
</style>

